import { Dialog, DialogContent, Divider, Slide } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { read } from "Helpers/LocalStorage";
import FactorService from "Services/http/endpoints/factor/FactorService";
import showNotify from "Helpers/Notify";
import { useSelector } from "react-redux";
import StatusHandler from "Helpers/StatusHandler";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import PageTitle from "Components/PageTitle/PageTitle";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import moment from "moment-jalaali";
import ShareFile from "Helpers/ShareFile";
import * as Icons from "react-bootstrap-icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewFactorDialog = ({ open, handleClose, data }) => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const reportRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(false);
  const { factorResult, selectedProject, factorSetting } = useSelector(
    (state) => ({
      factorResult: state.factor.factorResult,
      factorSetting: state.factor.factorSetting,
      selectedProject: state.project.selectedProject,
    })
  );

  const handlePrint = useReactToPrint({
    content: () => {
      if (reportRef.current) reportRef.current.style.transform = "scale(1)";
      return reportRef.current;
    },
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      if (reportRef.current)
        reportRef.current.style.transform = `scale(${scale})`;
      setLoading(false);
    },
  });

  useEffect(() => {
    if (open) {
      const scaleReport = () => {
        const reportElement = reportRef.current;
        if (reportElement) {
          const container = window.innerWidth;
          const reporter = reportElement.offsetWidth + 80;
          if (container > reporter) {
            setScale(1);
          } else if (reporter > 0) {
            const scaleFactor = container / reporter;
            setScale(scaleFactor);
          }
        }
      };
      setTimeout(scaleReport, 0);
      window.addEventListener("resize", scaleReport);
      return () => window.removeEventListener("resize", scaleReport);
    }
  }, [open]);

  const onClick = async () => {
    try {
      setLoading(true);
      const data = {
        ...factorResult,
        ...factorSetting,
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdProject: selectedProject.Id,
        OnlyPrice: false,
      };
      const response = await FactorService.saveArchiveFactor(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: t("Invoice_saved_successfully"),
          customClass: "success",
        });
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const handleShare = async () => {
    setLoading(true);
    ShareFile(
      "printPaper_invoice",
      `${
        factorSetting.IsFactor ? t("invoiceTitleMain") : t("invoiceTitlePre")
      }_${selectedProject.NameCustomer ? selectedProject.NameCustomer : ""}_${
        selectedProject.Name ? selectedProject.Name : ""
      }_${moment(new Date()).format("jYYYY/jM/jD")}`,
      `${
        factorSetting.IsFactor ? t("invoiceTitleMain") : t("invoiceTitlePre")
      } ${selectedProject.NameCustomer ? selectedProject.NameCustomer : ""} ${t(
        "projects"
      )} ${selectedProject.Name ? selectedProject.Name : ""} ${t(
        "moreInfoInShare"
      )}`
    );
    setLoading(false);
  };

  return (
    <Dialog
      dir={direction}
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <div className="dialogHeader">
        <BackDropLoading loading={loading} />
        <div className="page-top-title-button w-100">
          <PageTitle title={<Translator id="preview" />} />
          <div className="report-buttons">
            <MuiIconButton
              title={<Translator id={"save"} />}
              onClick={onClick}
              className="primary-button"
              icon={<Icons.Floppy size={17} />}
            />
            <MuiIconButton
              onClick={handleShare}
              title={<Translator id="share" />}
              className="primary-button"
              icon={<Icons.Share size={17} />}
            />
            <MuiIconButton
              title={<Translator id={"print"} />}
              onClick={handlePrint}
              className="primary-button"
              icon={<Icons.Printer size={17} />}
            />
            <Divider
              orientation="vertical"
              flexItem
              className="divider-factor"
            />
            <MuiIconButton
              onClick={handleClose}
              title={<Translator id="enseraf" />}
              className="danger-fill"
              icon={<Icons.XLg size={17} />}
            />
          </div>
        </div>
      </div>
      <DialogContent className="p-2">
        <div className="printPaper">
          <div
            className="inner-page"
            id="printPaper_invoice"
            ref={reportRef}
            style={{ transform: `scale(${scale})` }}
            dangerouslySetInnerHTML={{ __html: data }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewFactorDialog;
